import { signal, computed, effect } from '@preact/signals';

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'onmi.theme';

function readInitial(): Theme {
  if (typeof document !== 'undefined') {
    const attr = document.documentElement.getAttribute('data-theme');
    if (attr === 'dark' || attr === 'light') return attr;
  }
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
  } catch {
    // ignore
  }
  if (typeof matchMedia !== 'undefined' && matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

export const theme = signal<Theme>(readInitial());
export const isDark = computed(() => theme.value === 'dark');

effect(() => {
  const value = theme.value;
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', value);
  }
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore
  }
});

export function setTheme(next: Theme): void {
  theme.value = next;
}

export function toggleTheme(): void {
  theme.value = theme.value === 'dark' ? 'light' : 'dark';
}
